import React from 'react'
import styled from 'styled-components';
import media from 'css-in-js-media';

import { BodyCopy } from './Typography'
import AccordionWrap from './AccordionWrap'
import Container from './Container'
import Section from './Section'
import { Variables } from '../styles/Variables';

const StyledSection = styled(Section)`
    background-color: ${Variables.color.lightGrey};
    padding: 133px 172px;
    margin: 0;

    ${Container} {
        padding: 0;
    }

    ${media('<desktop')} {
        padding: 40px 20px;
    }
`;

const Accordion: React.FC<{
    data: object
}> = ({ data }) => {
    return (
        <StyledSection>
            <Container>
                <AccordionWrap>
                    {data.items.map((item, i) => {
                        const { title, copy } = item
                        return (
                            <div title={title} key={i}>
                                {copy && (
                                    <BodyCopy
                                        dangerouslySetInnerHTML={{
                                            __html: copy.childMarkdownRemark.html,
                                        }}
                                    />
                                )}
                            </div>
                        )
                    })}
                </AccordionWrap>
            </Container>
        </StyledSection>
    )
}

export default Accordion
